import BaseModelAPI from '../BaseModelAPI';

export default class PutawayConfiguration extends BaseModelAPI {
	static entity = 'putawayconfiguration';
	static entityName = 'putawayconfiguration';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.putawayCategoryId = '';
			this.putawayCategory = {};
			this.areaId = '';
			this.area = {};
			this.nextAreaId = '';
			this.nextArea = {};
			this.partClassificationId = '';
			this.partClassification = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}